import { MIXPANEL_PROPS } from 'utils/mixpanel'

import { PaywallType } from '../types'

export const typeToMixpanelProps: Record<PaywallType, string[]> = {
  csv: [MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.EXPORT_MODAL],
  keyword_ideas: [MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.LOAD_MORE],
  backlinks: [MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.BLOCK_OFF_DATA],
}
